export enum ComponentKey {
  InputText,
  InputWithUnit,
  DocumentUploader,
  DocumentSectionsUploader,
  Dropdown,
  SelectCard,
  ReferentialDropdown,
  Checkbox,
  Switch,
  RadioGroup,
  BankAccountSelector,
  GoogleLocation,
  DynamicArray,
  NumberSelector,
  ImageUpload,
  ColorPicker,
  TagInput,
  ReferentialTagInput,
  AutoComplete,
  NumberWithVariableUnit,
  Custom,
  CompanySearch,
  Iban,
}
